{
  "app": {
    "approveFailed": "承認に失敗しました: {{error}}",
    "archive": "アーカイブ",
    "archiveFailed": "アーカイブに失敗しました: {{error}}",
    "archiveThreadFailed": "アーカイブに失敗しました: {{error}}",
    "archiveThreadMessage": "「{{title}}」はサイドバーから非表示になります。会話履歴はディスク上に保持されます。",
    "archiveThreadMidTurn": "ターンの進行中はスレッドをアーカイブできません — 完了をお待ちください",
    "archiveThreadTitle": "スレッドをアーカイブしますか?",
    "bulkApproveAccepted": "✓ {{n}} 件承認 · {{parts}}",
    "bulkApproveFailed": "一括承認: {{total}} 件中 {{failed}} 件が失敗しました",
    "bulkApproveToCards": "{{n}}→カード",
    "bulkApproveToOpen": "{{n}}→OPEN",
    "cardArchived": "{{id}} をアーカイブしました",
    "cardDeleted": "{{id}} を削除しました",
    "cardDeletedBrokenReferences": "{{id}} を削除しました — 次のカードに無効な参照があります: {{refs}}",
    "cardDeletedBrokenRefs": "{{id}} を削除しました。無効な参照: {{refs}}",
    "cardMarkedStatus": "{{id}} を {{status}} としてマークしました",
    "cardSaved": "{{id}} を保存しました",
    "cardStatusCleared": "{{id}} のステータスをクリアしました",
    "cardWrittenBrokenRefs": "{{id}} を書き込みました。無効な参照: {{refs}}",
    "cardsMarkedStale": "{{id}} を再設定しました — 依存カード {{n}} 件を STALE としてフラグ付けしました",
    "cardsUndone": "{{n}} 件のカードを元に戻しました",
    "deleteFailed": "削除に失敗しました: {{error}}",
    "discard": "破棄",
    "discardChangesMessage": "開いているカードに未保存の編集があります。続行すると失われます。",
    "discardChangesTitle": "未保存の変更を破棄しますか?",
    "generateFailed": "生成に失敗しました: {{error}}",
    "markStatusFailed": "ステータスのマークに失敗しました: {{error}}",
    "packBlank": "空白",
    "packChanged": "pack を {{pack}} に切り替えました",
    "projectCreated": "プロジェクト「{{name}}」を作成しました",
    "projectDeleted": "プロジェクトを削除しました",
    "projectImported": "「{{name}}」をインポートしました",
    "proposalApproved": "{{id}} を承認しました → {{kind}}",
    "proposalRejected": "{{id}} を却下しました",
    "proposalRejectedMarked": "{{id}} を却下 · {{n}} 件のカードをマーク",
    "rejectFailed": "却下に失敗しました: {{error}}",
    "renameProjectFailed": "プロジェクト名の変更に失敗しました: {{error}}",
    "saveFailed": "保存に失敗しました: {{error}}",
    "setModelPreferenceFailed": "モデル設定の更新に失敗しました: {{error}}",
    "threadArchived": "スレッドをアーカイブしました",
    "threadTitleAnswer": "回答",
    "threadTitleDiscuss": "議論",
    "undo": "元に戻す",
    "undoDeleteFailed": "元に戻す: {{total}} 件中 {{failed}} 件の削除が失敗しました",
    "untitled": "無題",
    "cardsMarkedStaleFirst": "You just changed decision {{id}} — {{n}} dependent card(s) flagged stale. This is what separates Draftlize from a chat window: your thinking stays consistent."
  },
  "cardBody": {
    "jumpTo": "{{id}} へジャンプ"
  },
  "cardPeek": {
    "approveTooltip": "編集を適用して {{kind}} に昇格",
    "approving": "承認中…",
    "archive": "アーカイブ",
    "archiveTooltip": "レンズからソフト非表示 · wikilink は解決可能",
    "brokenRefs": "無効な参照:",
    "brokenRefsTooltip": "これらの wikilink ターゲットはプロジェクト内に存在しません。",
    "byAgent": "BY AGENT",
    "byYou": "BY YOU",
    "bySuggested": "SUGGESTED",
    "byRevised": "REVISED",
    "closeHint": "esc · 外側をクリックで閉じる",
    "closePeekAria": "ピークを閉じる",
    "confirmDelete": "{{id}} を完全に削除しますか?",
    "confirmReject": "{{id}} を却下して削除しますか?",
    "copy": "コピー",
    "customKindPlaceholder": "カスタム kind",
    "deleteReasonPlaceholder": "理由(任意、削除済みビューに表示)",
    "deleting": "削除中…",
    "editLabel": "EDIT",
    "fieldBody": "BODY",
    "fieldKind": "KIND",
    "fieldPack": "PACK",
    "fieldTitle": "TITLE",
    "history": "履歴",
    "historyTooltip": "このカードのすべての版を表示",
    "jumpTo": "{{id}} へジャンプ",
    "kindOther": "その他…",
    "markStatusTooltip": "このカードの実装ステータスをマーク",
    "implTimelineLabel": "実装ステータス",
    "implTimeline": {
      "proposed": {
        "label": "提案",
        "note": "議論で合意済み——コードはまだありません。"
      },
      "building": {
        "label": "構築中",
        "note": "コーディングエージェントが実装中です。"
      },
      "built": {
        "label": "実装済",
        "note": "リリース済み——実装はこのカードと一致しています。"
      },
      "drift_detected": {
        "label": "ドリフト",
        "note": "built 後にこのカードが変更されました——実装が古い可能性があります。"
      }
    },
    "packPlaceholder": "(なし)",
    "reject": "却下",
    "saveAndApprove": "保存して承認 → {{kind}}",
    "saveChangesTooltip": "変更を保存",
    "saveGapTooltip": "この gap を保存(承認はまだ保留中)",
    "saving": "保存中…",
    "seeHistoryOfDeleted": "削除済み {{id}} の履歴を表示",
    "stale": "· STALE",
    "statusBuilding": "building",
    "statusBuilt": "built",
    "statusClear": "(クリア)",
    "statusDriftDetected": "drift_detected",
    "statusProposed": "proposed",
    "unarchive": "アーカイブ解除",
    "unarchiveTooltip": "レンズへ復元(デフォルトの Time / Status ビュー)",
    "unsaved": "· UNSAVED",
    "uriTooltip": "Claude Code に @<この URI> を貼り付けてコンテキストに固定",
    "yesDelete": "はい、削除します",
    "yesReject": "はい、却下します"
  },
  "graphShare": {
    "title": "シェアカード",
    "building": "シェアカードを生成中……",
    "savePng": "画像を保存",
    "copyLink": "リンクをコピー",
    "copied": "コピー済み",
    "error": "生成に失敗しました：{{error}}",
    "sizeHint": "1080×1440",
    "statsCards_one": "{{count}} 枚のカード",
    "statsCards_other": "{{count}} 枚のカード",
    "statsDecisions_one": "{{count}} 件の意思決定",
    "statsDecisions_other": "{{count}} 件の意思決定",
    "tagline": "Draftlize でアイデアを孵化させよう"
  },
  "cardRow": {
    "brokenRefs": "無効な参照:",
    "brokenRefsTooltip": "これらの wikilink ターゲットはプロジェクト内に存在しません。",
    "byAgent": "BY AGENT",
    "byYou": "BY YOU",
    "bySuggested": "SUGGESTED",
    "byRevised": "REVISED",
    "implStatus": {
      "building": {
        "label": "BUILDING",
        "tooltip": "進行中"
      },
      "built": {
        "label": "✓ BUILT",
        "tooltip": "実装は出荷済み"
      },
      "drift_detected": {
        "label": "⚠ DRIFT",
        "tooltip": "実装後に仕様が変更されました。再ビルドまたは再マークしてください。"
      },
      "proposed": {
        "label": "PROPOSED",
        "tooltip": "ビルド対象として確認済み"
      }
    },
    "jumpTo": "{{id}} へジャンプ",
    "less": "— 折りたたむ",
    "mcpRecentTooltip": "過去 24 時間以内に外部 MCP クライアントから読み取られました",
    "more": "+ 展開",
    "pinManualTooltip": "ユーザーが手動で配置",
    "pinResetTooltip": "あなたがここに配置しました · クリックで LLM 配置にリセット",
    "seeHistoryOfDeleted": "削除済み {{id}} の履歴を表示",
    "stale": "· STALE",
    "unknownCard": "不明なカード"
  },
  "cards": {
    "addAFrame": "frame を追加",
    "addCardsFirst": "先にカードを追加してください",
    "addFrameMenu": "frame を追加…",
    "allCards": "ALL CARDS",
    "buildingExport": "エクスポートを作成中…",
    "cardCount_one": "{{count}} 枚のカード",
    "cardCount_other": "{{count}} 枚のカード",
    "cardsLandHere": "カードはここに表示されます。",
    "cardsLandHereBody": "agent がカードを書くと、このカラムに表示されます。約 6 枚たまるとシステムが frame への整理を手伝います。",
    "collecting": "COLLECTING…",
    "collectingBody_one": "6 枚中 {{count}} 枚のカードがあります。チャットを続けてください。6 枚たまると agent が構造を提案できます。",
    "collectingBody_other": "6 枚中 {{count}} 枚のカードがあります。チャットを続けてください。6 枚たまると agent が構造を提案できます。",
    "computingLayout": "レイアウトを計算中…",
    "deleteFrame": "frame を削除",
    "deleteFrameConfirm": "frame「{{name}}」を削除しますか? この frame でのカード配置は削除されますが、カード自体には影響しません。",
    "deleted": "DELETED",
    "deletedCount_one": "{{count}} 件削除済み",
    "deletedCount_other": "{{count}} 件削除済み",
    "errDelete": "削除",
    "errLoadFrame": "frame の読み込み",
    "errLoadFrames": "frame 一覧の読み込み",
    "errOverride": "上書き",
    "errRename": "名前の変更",
    "errReset": "リセット",
    "exportFailed": "エクスポートに失敗しました",
    "exportHint": ".zip をダウンロード — カード、削除記録、完全な履歴、スレッド",
    "exporting": "エクスポート中…",
    "frameMenu": "frame メニュー",
    "gapCountHint": "まだカードがない MECE 必須ノード",
    "gapCount_one": "{{count}} 件の gap",
    "gapCount_other": "{{count}} 件の gap",
    "generateDoc": "生成 · 設計ドキュメント",
    "generateDocHint": "設計ドキュメントを生成",
    "generating": "生成中…",
    "hidden": "HIDDEN",
    "hiddenHint": "このレンズから除外されています — ノードへドラッグで復元、または 📌 をクリックして LLM に判断させる",
    "lensStatus": "Status",
    "lensStatusSubtitle": "kind でグルーピング · decision → statement → gap → …",
    "lensTime": "Time",
    "lensTimeSubtitle": "新しい順 · デフォルト",
    "llmCategorized": "LLM が分類",
    "noCardsYet": "まだカードがありません。agent が書くとここに表示されます。",
    "noLensHint": "レンズなし — 全カードのフラットリスト",
    "nothingToExport": "エクスポートできるものがまだありません",
    "readyBody_one": "{{count}} 枚のカードがあります。frame を選んで整理しましょう — agent が書かれた内容に基づいて提案することも、テンプレートを選ぶこともできます。",
    "readyBody_other": "{{count}} 枚のカードがあります。frame を選んで整理しましょう — agent が書かれた内容に基づいて提案することも、テンプレートを選ぶこともできます。",
    "readyToOrganize": "READY TO ORGANIZE",
    "rename": "名前を変更",
    "renameFramePrompt": "frame の名前を変更",
    "seeDeletedHint": "削除されたカードを表示",
    "showArchived": "アーカイブを表示",
    "showArchivedHint": "ソフト非表示のカード(テスト/不要なカードなど) — wikilink 解決のために DB に保持され、レンズではデフォルト非表示",
    "staleDocsAria_one": "{{count}} 件の STALE ドキュメント",
    "staleDocsAria_other": "{{count}} 件の STALE ドキュメント",
    "staleDocsHint_one": "{{count}} 件の保存済みドキュメントが STALE の可能性があります — 開いて確認してください",
    "staleDocsHint_other": "{{count}} 件の保存済みドキュメントが STALE の可能性があります — 開いて確認してください",
    "unplaced": "UNPLACED",
    "unplacedHint": "明確な分類なし — 決まったらノードへドラッグ",
    "viewHidden_one": "非表示を表示({{count}})",
    "viewHidden_other": "非表示を表示({{count}})",
    "staleDemoPrompt": "Try the killer mechanic: edit this decision and watch dependent cards flag themselves stale.",
    "staleDemoCta": "TRY IT",
    "staleDemoDismiss": "Dismiss"
  },
  "columnResizer": {
    "resizeHandle": "ディスカッションパネルのサイズを調整。矢印キーで微調整、Shift で大きく、ダブルクリックまたは Enter でリセット。",
    "showCards": "カードを表示"
  },
  "common": {
    "back": "戻る",
    "cancel": "キャンセル",
    "close": "閉じる",
    "delete": "削除",
    "edit": "編集",
    "loading": "読み込み中…",
    "refresh": "更新",
    "retry": "再試行",
    "save": "保存"
  },
  "computed": {
    "badgeTooltip": "このカードの値は python_compute サンドボックス実行で検証されています。カードを開いてコードを確認できます。",
    "durationMs": "{{ms}} ms",
    "exitCode": "exit {{code}}",
    "inputs": "入力:",
    "label": "π computed",
    "runNumber": "run #{{id}}",
    "stdout": "STDOUT"
  },
  "confirm": {
    "confirm": "確認"
  },
  "dcard": {
    "stale": "STALE"
  },
  "deleted": {
    "backToCards": "カードに戻る",
    "byAgent": "BY AGENT",
    "byFs": "BY FS",
    "byYou": "BY YOU",
    "daysAgo": "{{count}}日前",
    "emptyState": "削除されたカードはまだありません",
    "groupAgentEdit": "agent が削除",
    "groupFsDelete": "fs 削除",
    "groupOther": "その他",
    "groupRejectedGap": "却下された gap",
    "groupResolvedGap": "解決された gap",
    "groupUserDelete": "あなたが削除",
    "heading": "DELETED",
    "viewFullHistory": "完全な履歴を表示",
    "yesterday": "昨日"
  },
  "discussion": {
    "addToCards": "カードに追加",
    "addToOpen": "OPEN に追加",
    "agentDecidesHint": "カードを書くタイミングは agent が判断します",
    "answerNow": "今すぐ回答",
    "attachRefTooltip": "プロジェクト ref を添付",
    "attachedChipTooltip": "プロジェクト ref として添付済み · × をクリックして自動メンションを解除",
    "attachedRemoveAria": "{{name}} を削除",
    "bulkAcceptAll": "すべて承認({{parts}})",
    "bulkAddAllToCards": "すべてカードに追加({{count}})",
    "bulkAddAllToOpen": "すべて OPEN に追加({{count}})",
    "bulkApproveAllTooltip": "このバーストのすべての提案を承認",
    "bulkBreakdownAllQuestions": "(すべて question)",
    "bulkBreakdownAllSettled": "(すべて確定済み)",
    "bulkBreakdownMixed": "({{questions}} 件の question、{{other}} 件のその他)",
    "bulkExpandTooltip": "個々の提案を展開し、1 件ずつ対応できるようにします",
    "bulkPartCards": "{{count}}→カード",
    "bulkPartOpen": "{{count}}→OPEN",
    "bulkProposalsCount": "{{count}} 件の提案",
    "bulkProposalsExpanded": "{{count}} 件の提案 · 展開済み",
    "bulkRejectAllTooltip": "このバーストのすべての提案を却下",
    "clickToDismiss": "クリックで閉じる",
    "collapse": "折りたたむ",
    "composerDropPlaceholder": "ドロップしてプロジェクト ref として添付",
    "composerPlaceholder": "agent と一緒に考えを話してみましょう…",
    "convertItemsMany": "↳ {{count}} 件の項目を変換 → OPEN",
    "convertItemsOne": "↳ {{count}} 件の項目を変換 → OPEN",
    "convertTooltip": "このメッセージに限定して decompose-distill を実行し、項目を OPEN に表示します。",
    "converting": "CONVERTING…",
    "discuss": "議論",
    "dismiss": "却下",
    "dismissAll": "すべて却下",
    "distillButton": "DISTILL ⌘D",
    "distillTooltip": "会話を振り返り、書いておくべきだったカードを提案",
    "distilling": "DISTILLING…",
    "emptyBody": "agent は自由に対話し、本質を突く質問を投げかけ、機が熟したらカードを書きます。最後にいつでも Distill を実行して、漏れた内容を拾うことができます。",
    "emptyTitle": "曖昧なアイデアから始めましょう。",
    "expand": "展開",
    "headerTitle": "DISCUSSION",
    "jumpToLatestTooltip": "最新メッセージへジャンプ",
    "newReplyMany": "↓ {{count}} 件の新着返信",
    "newReplyOne": "↓ {{count}} 件の新着返信",
    "openProjectFirst": "先にプロジェクトを開いてください",
    "pinnedApproveQuestionTooltip": "question は承認できません — 回答を書いてからアーカイブしてください",
    "pinnedApproveTooltip": "昇格 → {{kind}}(提案された kind)",
    "pinnedBadgeAnswering": "✦ ANSWERING {{id}}",
    "pinnedBadgeDiscussing": "✦ DISCUSSING {{id}}",
    "pinnedRejectTooltip": "却下 — gap を削除し、ブロックを却下済みとしてマーク",
    "pinnedResolveTooltip": "この gap への会話の誘導を停止(gap は台帳に残ります)",
    "pinnedWhyPrefix": "理由:",
    "postResolveDismiss": "DISMISS",
    "postResolvePrefix": "解決済み",
    "postResolveSuffix": "。このディスカッションで新たな gap は見つかりましたか?",
    "queuedCancelAria": "キューに入った送信をキャンセル",
    "queuedChipTooltip": "キュー済み — 現在のターン終了後に送信 · × でキャンセル",
    "queuedImageMany": "({{count}} 枚の画像)",
    "queuedImageOne": "({{count}} 枚の画像)",
    "queuedPrefix": "↵ キュー済み:",
    "resolve": "解決",
    "roleAgent": "✦ AGENT · {{time}}",
    "roleYou": "YOU · {{time}}",
    "runAudit": "RUN AUDIT",
    "sandboxRunning": "🐍 sandbox 実行中",
    "sendButtonQueue": "キュー",
    "sendButtonQueueTooltip": "キュー(↵) — 現在のターン終了後に送信",
    "sendButtonSend": "送信",
    "sendButtonSendTooltip": "送信(↵) · ⇧↵ で改行",
    "sendButtonStop": "停止",
    "sendButtonStopAria": "進行中のターンを停止",
    "sendButtonStopTooltip": "停止 — 進行中のターンを中断",
    "thinkingChars": "{{count}} 文字",
    "thinkingLabel": "✦ THINKING · {{time}}",
    "thinkingPlaceholder": "✦ 思考中",
    "tierChipTooltip": "ティア: {{tier}}{{suffix}} — クリックで変更",
    "tierCustomLabel": "カスタム:",
    "tierDefaultBadge": "DEFAULT",
    "tierEffortHeading": "EFFORT",
    "tierEffortIgnoredTooltip": "Fast モードが有効です — リクエスト時に effort は無視されます。",
    "tierFastMode": "Fast モード",
    "tierFastModeTooltip": "思考を完全にスキップ。推論品質と引き換えに初回応答までの時間を短縮します。",
    "tierModelsHeading": "MODELS",
    "tierResetToDefault": "RESET TO DEFAULT",
    "tierVisionStickyNote": "このスレッドには画像が含まれます。選択にかかわらず、過去のターンが読める状態を保つため、サーバーは自動的に視覚対応モデルにルーティングします。",
    "tierVisionStickyTooltip": "Vision sticky: このスレッドには画像が含まれるため、選択にかかわらずサーバーは視覚対応モデルにルーティングします。クリックで変更可能です。",
    "toolApproveQuestionTooltip": "open question として OPEN QUESTIONS に追加",
    "toolApproveTooltip": "{{kind}} としてカードに追加",
    "toolApprovedSummary": "✓ 承認済み → {{id}} ({{kind}})",
    "toolDiscussQuestionTooltip": "スレッドを開いて agent と一緒にこの question に回答",
    "toolDiscussTooltip": "スレッドを開いて承認前にこの提案を練り上げる",
    "toolJumpTooltip": "クリックで {{id}} へジャンプ",
    "toolRejectTooltip": "却下 — 提案を削除し、ブロックを却下済みとしてマーク",
    "toolToggleTooltip": "クリックで入力全体を表示/折りたたみ",
    "truncatedLabel": "⚠ TRUNCATED · max_tokens に到達 — 応答が途切れました",
    "truncatedTooltip": "モデルが max_tokens に到達して停止しました。DRAFTLIZE_MAX_TOKENS を引き上げるか、agent に続行を依頼してください。",
    "untitledGap": "(無題の gap)",
    "untitledQuestion": "(無題の question)",
    "uploadFailed": "アップロードに失敗しました: {{error}}",
    "uploading": "{{count}} 件をアップロード中…",
    "working": "処理中…"
  },
  "distill": {
    "blocksPrefix": "blocks:",
    "cardsSection": "CARDS · {{total}} 件中 {{selected}} 件",
    "cardsSectionHint": "結晶化されたコンテンツ — コミット時に write_card で直接書き込み",
    "commit": "{{count}} 件をコミット",
    "extractedSoFar": "これまでに {{count}} 件の項目を抽出しました",
    "failed": "Distill に失敗しました: {{message}}",
    "gapsSection": "GAPS · {{total}} 件中 {{selected}} 件",
    "gapsSectionHint": "open 項目 — コミット時に propose_card で OPEN に表示",
    "headerHint": "カード: 直接書き込み · gap: OPEN に表示",
    "heading": "スレッドを Distill",
    "hintAudit": "監査レンズでプロジェクト全体の gap を棚卸し · 優先度付きの gap が中心",
    "hintDecompose": "agent の構造化された成果物(リスト / 階層)を原子的な項目に分解",
    "hintRescue": "このスレッドで取りこぼされた結晶化を拾う · gap 寄り",
    "modeAudit": "監査",
    "modeDecompose": "分解",
    "modeRescue": "回収",
    "nothingToExtract": "抽出するものがありません。",
    "nothingToExtractHint": "このスレッドからは新しい結晶化された内容や open 項目は得られませんでした。まだ探索段階か、agent がすでに対話中に捕捉済みです。",
    "reading": "読み込み中…",
    "scanning": "SCANNING THE THREAD",
    "scanningHint": "会話からのカード + gap",
    "selectedBreakdown": "({{cards}} 枚のカード · {{gaps}} 件の gap)",
    "selectedCount": "{{total}} 件中 {{selected}} 件を選択",
    "whyPrefix": "理由:"
  },
  "documents": {
    "cardCount": "{{count}} 枚のカード",
    "confirmDelete": "「{{title}}」を削除しますか? この操作は元に戻せません。",
    "emptyBody": "左側でテンプレートを選び、カードから新しいドキュメントを生成しましょう。保存したドキュメントはこのリストに再表示されます。ソースカードが変更されると STALE のフラグを立てるので、再生成のタイミングがわかります。",
    "emptyList": "保存されたドキュメントはまだありません。上のテンプレートを選んで生成してください。",
    "emptyTitle": "長文のコンテンツはここに置かれます。",
    "errDelete": "削除: {{message}}",
    "heading": "ドキュメント",
    "newFromTemplate": "+ テンプレートから新規",
    "regenerate": "再生成",
    "savedCount": "{{count}} 件保存済み",
    "stale": "STALE",
    "staleBanner": "生成時から、ソースカードのうち 1 つ以上が変更されています。",
    "templatesToggle": "▴ テンプレート",
    "share": "Share",
    "shareCopied": "Link copied"
  },
  "frame": {
    "acceptAndUse": "採用して使用",
    "designSectionHeading": "カードから frame を設計",
    "designingBody": "カードを読み込み、あなたが実際に書いた内容に基づいてトポロジーを構築しています。経過時間: {{seconds}} 秒。",
    "designingCardCount": "{{count}} 枚のカード",
    "designingTopology": "トポロジーを設計中",
    "errCloneFailed": "クローンに失敗しました: {{message}}",
    "errLoadTemplates": "テンプレートの読み込みに失敗しました: {{message}}",
    "errSaveFailed": "保存に失敗しました: {{message}}",
    "errSuggestFailed": "提案に失敗しました: {{message}}",
    "haveAgentDesign": "agent に設計してもらう",
    "headingAdd": "frame を追加",
    "headingSuggested": "提案された frame",
    "meceTag": "[MECE]",
    "nodeCount": "{{count}} 個のノード",
    "orPickTemplate": "またはテンプレートを選択",
    "proposedTopology": "提案されたトポロジー · {{nodes}} 個のノード · {{cards}} 枚のカードから派生",
    "recommendedByPack": "★ {{pack}} pack の推奨",
    "saving": "保存中",
    "suggestNeedMore": "少なくとも 6 枚のカードが必要です(現在 {{count}} 枚)。チャットを続けて再度お試しください。",
    "suggestReady": "{{count}} 枚のカードを読み込み、実際に書かれた内容に基づいたトポロジーを提案します。約 10–30 秒。"
  },
  "gaps": {
    "answer": "回答",
    "answerTitle": "スレッドを開いて agent と一緒にこの question を解決",
    "approveTitleCard": "{{kind}} として追加(カード列に加わります)",
    "approveTitleQuestion": "OPEN QUESTIONS に question として追加",
    "approveToCards": "カードに追加",
    "approveToOpen": "OPEN に追加",
    "archive": "アーカイブ",
    "archiveTitle": "この question をソフト非表示 — wikilink は解決可能",
    "auditButton": "+ AUDIT",
    "auditGapsButton": "+ AUDIT GAPS",
    "auditInProgress": "audit 実行中…",
    "auditNeedsThread": "先にスレッドを開くか作成してください",
    "auditTitle": "プロジェクト全体の gap audit を実行 — 具体的な gap を OPEN に展開します",
    "auditingBusy": "AUDITING…",
    "blocksLabel": "blocks:",
    "citedLabel": "引用:",
    "citedTitle": "ホバーで引用されたターンをハイライト。ターン ID をクリックでジャンプ",
    "collapse": "折りたたむ",
    "discuss": "議論",
    "discussTitle": "この gap をディスカッションにピン留めして一緒に解決",
    "dismiss": "却下",
    "dismissTitle": "却下 — 提案を削除し、ブロックを却下済みとしてマーク",
    "emptyState": "open な項目はありません。agent が unknown をフラグしたり、カードを提案したり、audit を実行したりすると、ここに表示されます。",
    "expand": "展開",
    "frameLabel": "frame",
    "heading": "OPEN",
    "hidePanel": "OPEN パネルを非表示",
    "jumpTo": "{{id}} へジャンプ",
    "jumpToTurn": "ディスカッションの {{turn}} へジャンプ",
    "nodeEmpty": "{{label}} は空です",
    "openCard": "このカードを開く",
    "openProbeCount": "{{count}} 個の probe question を開く",
    "openProbePopover": "probe ポップオーバーを開く",
    "priorityNone": "UNSORTED",
    "priorityP0": "P0 — BLOCKER",
    "priorityP1": "P1 — SUBSYSTEM",
    "priorityP2": "P2 — POLISH",
    "priorityP3": "P3 — INFRA / OPS",
    "questionLabel": "question",
    "railExpand": "OPEN パネルを展開",
    "railExpandCount": "{{count}} 件の open 項目 — クリックで展開",
    "refsLabel": "refs:",
    "sectionFrameGaps": "FRAME GAPS",
    "sectionOpenQuestions": "OPEN QUESTIONS",
    "sectionPendingReview": "PENDING REVIEW",
    "sectionStaleRipple": "STALE RIPPLE",
    "untitled": "(無題)",
    "untitledProposal": "(無題の提案)",
    "untitledQuestion": "(無題の question)",
    "whyPrefix": "理由:"
  },
  "generate": {
    "copied": "コピー済み ✓",
    "copyMarkdown": "markdown をコピー",
    "copyTitle": "markdown をクリップボードにコピー",
    "downloadMd": ".md をダウンロード",
    "downloadTitle": ".md としてダウンロード",
    "fromCards": "{{count}} 枚のカードから",
    "heading": "生成済み · {{template}}",
    "saveFailed": "保存に失敗しました: {{message}}",
    "saveTitle": "ドキュメントをプロジェクトに保存",
    "saved": "保存済み ✓",
    "savedTitle": "ドキュメントを保存しました",
    "saving": "保存中…",
    "streaming": "ストリーミング中…",
    "titlePlaceholder": "ドキュメントタイトル…",
    "viewRaw": "Raw",
    "viewRendered": "Rendered",
    "waitStreaming": "ストリーミングの完了をお待ちください"
  },
  "history": {
    "byAgent": "BY AGENT",
    "byFs": "BY FS",
    "byYou": "BY YOU",
    "closeAria": "履歴を閉じる",
    "current": "CURRENT",
    "daysAgo": "{{count}}日前",
    "diffNoPrior": "diff(前の版なし)",
    "diffVsRev": "rev {{rev}} との diff",
    "fieldBody": "body",
    "fieldKind": "kind",
    "fieldPack": "pack",
    "fieldTitle": "title",
    "filterFs": "fs",
    "filterFsTooltip": "ファイルシステムからの編集(vim、Obsidian、git pull)を表示",
    "filterMetadata": "metadata",
    "filterMetadataTooltip": "extra/metadata のみ変更された rev を表示(例: dismissed_gaps)",
    "hiddenCount": "{{count}} 件非表示",
    "noMatch": "現在のフィルターに一致する版はありません",
    "none": "(なし)",
    "opDelete": "DELETE",
    "opFs": "FS",
    "opPatch": "PATCH",
    "opPromote": "PROMOTE",
    "opWrite": "WRITE",
    "restore": "復元",
    "restoreConfirm": "復元",
    "restoreMessage": "{{cardId}} の現在の body は、この版の内容で上書きされます。復元自体は新しい rev として記録されます — 何も失われませんが、履歴に変更として表示されます。",
    "restoreTitle": "rev {{rev}} を復元しますか?",
    "restoreTooltip": "この版を現在の body として復元",
    "restoring": "復元中…",
    "revCount_one": "{{count}} 件の rev",
    "revCount_other": "{{count}} 件の rev",
    "revLabel": "rev {{rev}}",
    "snapshot": "スナップショット",
    "startsHere": "履歴はここから始まります",
    "title": "HISTORY",
    "undeleteConfirm": "削除を取り消す",
    "undeleteMessage": "この版の内容からカードが再作成されます。復元は新しい rev として記録されるため、削除イベントは履歴に保持されます。",
    "undeleteTitle": "{{cardId}} の削除を取り消しますか?",
    "yesterday": "昨日"
  },
  "homepage": {
    "ccBullet1Body": "· さらにスレッドとドキュメントのリーダーも。書き込みは fact / statement / question にロックされ、decision はあなたのものです。",
    "ccBullet1Label": "MCP · READ",
    "ccBullet1Title": "5 つの読み取りツール、1 つの安全な書き込み",
    "ccBullet2BodyPart1": "ビルドセッションの発見は、",
    "ccBullet2BodyPart2": " とタグ付けされた gap カードとして返ってきます。台帳でトリアージし、CLI が代わりに decision を確定することはありません。",
    "ccBullet2Label": "CLI · PROPOSE",
    "ccBullet2Title": "flag · fact · mark-built",
    "ccBullet3BodyPart1": "一度カードが ",
    "ccBullet3BodyPart2": " になると、その body への編集が drift ビットを立てます。仕様が動いてコードが追随していない箇所が UI に表示されます。",
    "ccBullet3Label": "DRIFT DETECTION",
    "ccBullet3Title": "仕様 ↔ コードの自動フラグ",
    "ccHeadingLine1": "カードを環境コンテキストに。",
    "ccHeadingLine2": "発見を gap 提案に。",
    "ccIntroPart1": "Draftlize は ",
    "ccIntroPart2": "(独立した ",
    "ccIntroPart3": " バイナリ)と、カードをリポジトリにミラーリングする ",
    "ccIntroPart4": " として提供されます。Claude Code、Cursor、vim が環境コンテキストとして読み取り、発見はあなたがトリアージする gap 提案として返ってきます。",
    "ccIntroStrong1": "MCP サーバー",
    "ccIntroStrong2": "CLI",
    "ccLabel": "FIG. 5 · EXTERNAL AGENTS",
    "compareColChatGPT": "ChatGPT / Claude",
    "compareColDraftlize": "Draftlize",
    "compareColLinear": "Linear Docs",
    "compareColNotion": "Notion AI",
    "compareHeading": "プロダクト思考のために設計、",
    "compareHeadingEm": "汎用ノートではなく。",
    "compareIntro": "汎用ノートアプリは静的ドキュメント向けに作られました。ChatGPT はステートレスチャット向けに作られました。Draftlize は、プロダクト決定が会話・エージェント・スプリントを跨いで複利化する初の substrate です。",
    "compareLabel": "なぜ Draftlize",
    "compareLegendNo": "—",
    "compareLegendPartial": "部分対応",
    "compareLegendYes": "ネイティブ",
    "compareRow1": "チャット間で context を保持",
    "compareRow2": "仕様変更時に依存を自動 stale 表示",
    "compareRow3": "決定はアドレス可能、散文に埋もれない",
    "compareRow4": "スレッド間の競合検出",
    "compareRow5": "Claude Code / Cursor / MCP のファーストクラス context",
    "compareRow6": "カードレベルの履歴 + 出所（誰が・いつ・なぜ）",
    "compareRow7": "グラフ全体をいつでも markdown でエクスポート",
    "demoAriaLabel": "STALE 伝播デモ",
    "demoButtonIdle": "c-04 を書き換え →",
    "demoButtonReset": "リセット ↻",
    "demoButtonWriting": "書き込み中…",
    "demoByYou": "BY YOU",
    "demoCardDecision": "魔法システム: {{value}}",
    "demoCardDecisionPrefix": "魔法システム:",
    "demoCardQuestion": "2 つ目のスロットがアンロックされた後、属性切替を UI でどう表現する?",
    "demoCardStatement1": "ボス「Pyrhad」の弱点 — 水属性のバースト dmg が戦闘ペースを決める",
    "demoCardStatement2": "ステージ 3 の隠しルートには土属性キャラが最低 1 体必要",
    "demoNarrateIdle": "decision を 1 つ変える · 依存項目が STALE となるのを見る",
    "doc1Bul1": "Free 層の 0.1× クォータが Pro 転換を促進",
    "doc1Bul2": "Max はセルフホスト経路をカニバライズする可能性あり",
    "doc1Cards": "14 CARDS",
    "doc1Hdg1": "## 背景",
    "doc1Hdg2": "## 決定",
    "doc1Hdg3": "## トレードオフ",
    "doc1Hdg4": "## オープン",
    "doc1Row1": "ターゲット: 独立系カフェオーナー、月25ドルのツール予算上限",
    "doc1Row2": "前払いウォレット · 従量課金 · $5 進呈",
    "doc1Row3": "ヘビーユーザーのペルソナ",
    "doc1Stale": "2 STALE",
    "doc2Cards": "9 CARDS",
    "doc2Hdg1": "1 · 問題",
    "doc2Hdg2": "2 · メカニズム",
    "doc2Hdg3": "3 · デモ",
    "doc2Hdg4": "4 · 市場",
    "doc2Hdg5": "5 · ビジネス",
    "doc2Row1": "AI チャットは 30 ターン目以降で劣化する",
    "doc2Row2": "カードグラフ + STALE 伝播",
    "doc2Row3": "UC-01 happy path",
    "doc2Row4": "AI ネイティブの運用者",
    "doc2Row5": "前払いウォレット",
    "doc3Body1Em": "議論が深まらなくなる",
    "doc3Body1Part1": "30 ターン目までに、ほとんどの人が同じことに気づきます。",
    "doc3Body1Part2": "、そして薄まり始める、と。モデルが壊れているのではない — 成果物が欠けているのです…",
    "doc3Body2Em": "decision",
    "doc3Body2Part1": "1 つの ",
    "doc3Body2Part2": " カードを書き換える。依存する思考はすべて STALE フラグが立ち、取り消し線が引かれ、琥珀色に染まります…",
    "doc3Cards": "6 CARDS",
    "doc3Hdg1": "なぜ Draftlize なのか",
    "doc3Hdg2": "メカニズム",
    "doc3Stale": "1 STALE",
    "doc4Bul1": "ビジョン · 一行の立ち位置",
    "doc4Bul2": "存在理由(2 つの信念)",
    "doc4Bul3": "└ ノートではなく成果物",
    "doc4Bul4": "└ 思考そのものがコラボレーション",
    "doc4Bul5": "v3 から引き継ぐもの",
    "doc4Bul6": "エッジ — PG を単一の事実源として",
    "doc4Bul7": "成功基準(5)",
    "doc4Cards": "22 CARDS",
    "docClean": "CLEAN",
    "docTemplate1Label": "TEMPLATE 01",
    "docTemplate2Label": "TEMPLATE 02",
    "docTemplate3Label": "TEMPLATE 03",
    "docTemplate4Label": "TEMPLATE 04",
    "docsHeadingLine1": "下書きを生成する。",
    "docsHeadingLine2": "カードを真実として保つ。",
    "docsIntroEm": "派生ビュー",
    "docsIntroPart1": "ドキュメントは ",
    "docsIntroPart2": " です。各行はテンプレート + markdown + ",
    "docsIntroPart3": " を保持します。参照されたカードが変わると、バックグラウンドの検出器が SSE 経由で ",
    "docsIntroPart4": " をプッシュ — ソースがドリフトした瞬間、琥珀色の点が現れます。",
    "docsLabel": "FIG. 4 · LONG-FORM OUTPUT",
    "edition": "VOL. 1 · 2026 EDITION",
    "faq1AnswerPart1": "いいえ。サブスクはありません——従量課金です。登録すると $5 のクレジットが進呈され、使った分だけ残高から差し引かれます。残高がなくなったら $5 からチャージするだけ。月額固定費も、最低利用額もありません。残高は",
    "faq1AnswerPart2": "失効せず、解約という概念もなく、いつでも全データをエクスポートできます。",
    "faq1Question": "サブスクは必要ですか？",
    "faq2Answer": "いつでも。すべての card / thread / document / history / ref ファイルを完全な markdown でエクスポート。プレーンテキスト——ロックインなし、独自フォーマットなし。Obsidian、Notion、vim、お好きな場所へ。",
    "faq2Question": "データをエクスポートできますか？",
    "faq3Answer": "あなたのカードは常にあなたのものです。あなたのデータでモデルを訓練することは絶対にありません。Server は Fly.io でステートレスコンテナを実行；データはテナント分離された Postgres + Tigris S3 にあります。データ削除リクエストは 7 日以内に実行されます。",
    "faq3Question": "プライバシー / データ所有権は？",
    "faq4Answer": "既存の markdown / PDF / ドキュメントを _refs/ パネルにドラッグすると、エージェントがカードを抽出します。ワンクリックインポートはまだありません——ただしエージェントが与えたものを読み、カード単位で Approve / Reject 用に提案します。多くの PM が既存文書から有用なプロジェクトを 30-60 分でシードできたと報告しています。",
    "faq4Question": "Notion / Linear / 既存ドキュメントから移行するには？",
    "faq5Answer": "従量課金なので、使った分だけ残高から差し引かれます。残高が少なくなったら $5 からチャージするだけ。階層（ティア）もハードキャップもなく、機能はすべて同じ——支払った残高がそのまま使えます。残高は失効せず、未使用分が消えることもありません。",
    "faq5Question": "使い切ったらどうなりますか？",
    "faqHeading": "よくある質問",
    "finalBody": "プロダクト思考を AI エージェントが読み書きできる substrate に置きましょう。登録で $5 クレジット進呈、あとは従量課金。残高は失効せず、サブスクも解約も不要。",
    "finalCta": "ENTER WITH INVITE CODE",
    "finalHeadingLine1": "もうアーティファクトを失わない。",
    "finalHeadingLine2": "残し始める。",
    "footerAriaGitHub": "GitHub でサインイン",
    "footerAriaGoogle": "Google でサインイン",
    "footerAriaMagicLink": "メールのマジックリンクでサインイン",
    "footerBlurb": "agent ネイティブなアイデアインキュベーター。セルフホストの Rust agent、Postgres + pgvector、S3 ベースの refs の上に構築。クローズドソースの SaaS — あなたのデータはいつでも markdown としてエクスポートできます。",
    "footerContact": "CONTACT",
    "footerEdition": "VOL. 1 · ISSUE 1 · GLOBAL EARLY ACCESS · 2026 EDITION",
    "footerGitHub": "GITHUB",
    "footerGoogle": "GOOGLE",
    "footerLanguage": "LANGUAGE",
    "footerLanguageNote": "スレッドごとに上書き可",
    "footerMagicLink": "MAGIC LINK",
    "footerPrivacy": "PRIVACY",
    "footerSignIn": "SIGN IN",
    "footerTerms": "TERMS",
    "founderBody": "新しい Claude チャットを開くたびに、なぜ freemium モデルを止めたか、オンボーディングの決定は何だったか、なぜ Lemon ではなく Stripe を選んだかを再説明していました。3 スプリント目で気付きました——私はプロダクト作業ではなく context 復旧をしていたと。だから AI が読み書きできる決定 substrate を作りました、チャット履歴で「見る」だけではなく。Draftlize は私が毎日使うものです。AI チャットの中で生活し、半週を再説明に費やしている PM なら、あなたが私が作っている対象です。",
    "founderHeading": "context の再説明に",
    "founderHeadingEm": "疲れた PM より。",
    "founderLabel": "なぜ作ったか",
    "founderSig": "— Draftlize 創業者",
    "gainLabel": "GAIN",
    "heroCtaReadMechanic": "メカニズムを読む",
    "heroCtaStartFree": "ENTER WITH INVITE CODE",
    "heroLabel": "Limited beta — invite only",
    "heroLedePart1": "PM とプロダクトデザイナーのために。すべての spec、決定、根拠が",
    "heroLedePart2": "になります。spec を 1 つ変更すると、依存するすべてのスレッドが",
    "heroLedePart3": "されます。決定がスプリントごとに蒸し返されることはなくなります。",
    "heroLedeStrong1": "アドレス可能なカード",
    "heroLedeStrong2": "自動で stale 表示",
    "heroRoiLine": "PM は週 5 時間以上を AI への context 再説明に失っています。Draftlize はそれを保持します。",
    "heroStack1": "SELF-HOSTED RUST AGENT",
    "heroStack2": "POSTGRES + PGVECTOR",
    "heroStack3": "MCP + CLI · CLAUDE CODE-READY",
    "heroTitleLine1": "agent と思考する。",
    "heroTitleLine2": "成果物を保つ。",
    "mechanic1BodyPart1": "各カードは構造化された原子です — ",
    "mechanic1BodyPart2": " wikilink がエッジを描きます。「メインドキュメント + 添付」の二重構造はありません。",
    "mechanic1Title": "カードグラフ自体がドキュメント。",
    "mechanic2BodyPart1": "1 つの ",
    "mechanic2BodyPart2": " を書き換える → 基層が ",
    "mechanic2BodyPart3": " を逆方向にたどる → すべての推移的な依存項目が ",
    "mechanic2BodyPart4": " UI は取り消し線を引き、琥珀色でフラグします。",
    "mechanic2Title": "STALE 伝播は第一級の挙動。",
    "mechanic3BodyPart1": "agent が確信を持てないとき、",
    "mechanic3BodyPart2": " は ",
    "mechanic3BodyPart3": " を 1 つ落とします。常に見え、折りたためません。承認 · 議論 · 却下。",
    "mechanic3Title": "Gap Ledger は 4 列目に常駐。",
    "mechanic4BodyPart1": "1 つのプロジェクトで複数のスレッドを開けます — カードを共有しますが、チャット履歴は共有しません。バックグラウンドの検出器がスレッド間の矛盾を ",
    "mechanic4Title": "マルチスレッドと自動矛盾検出。",
    "mechanicHeadingLine1": "4 つの動き、",
    "mechanicHeadingLine2": "これをノートアプリではなくする。",
    "mechanicLabel": "FIG. 1 · CORE MECHANIC",
    "mockCardDecision": "前払いウォレット · 従量課金 · 残高は失効しない",
    "mockCardGap": "market-research/c-31 は予算 35〜50ドル — c-09 と矛盾",
    "mockCardStatement1": "独立系カフェオーナーは月のツール予算を約25ドルで打ち止め — 従量課金ならどんな予算にも収まる",
    "mockCardStatement2": "$5 のサインアップクレジットで、チャージ前に試せる",
    "mockCards": "CARDS",
    "mockGapConflict": "予算の数字がスレッド間で矛盾",
    "mockGapInterp1": "「独立系カフェ」 — 小規模チェーンを含むか?",
    "mockGapInterp2": "ヘビーユーザーのペルソナが未定義",
    "mockGapLedger": "GAP LEDGER",
    "mockThreads": "THREADS",
    "navDocuments": "DOCUMENTS",
    "navEarlyAccess": "EARLY ACCESS →",
    "navMechanic": "MECHANIC",
    "navPeople": "PEOPLE",
    "navPricing": "PRICING",
    "navProblem": "PROBLEM",
    "painLabel": "PAIN",
    "persona1Gain": "カードが永続記憶。新スレッドで agent が c-04（価格決定）と c-09（ターゲット層）を ambient context として読み込む。再説明はゼロに。spec を変更すると依存スレッドが自動で stale 表示、決定が drift しない。",
    "persona1Name": "プロダクトマネージャー",
    "persona1Pain": "新しい Claude チャットを開くたびに、数週間前に決めた価格、ターゲット層、オンボーディング決定を再議論。金曜には第 2 週で決めた context の再説明に 8 時間費やしていることに気付く。",
    "persona1Role": "Mira — シリーズ A SaaS のシニア PM、Claude を思考パートナーとしてロードマップを進める",
    "persona1Snippet": "\"AI 支援 PM 作業を週 12 時間から 6 時間に削減。同じ成果、再説明半減。\"",
    "persona1SnippetLabel": "DOGFOOD より · 第 4 週",
    "persona1Tag": "№ 01 · PM",
    "persona2GainPart1": "あらゆるデザイン決定がカード。agent は c-03（色原則）と c-22（コンポーネントロックアップ根拠）を先に読んでから変更を提案。面間の矛盾が PR 開始前に",
    "persona2GainPart2": "として表面化。",
    "persona2Name": "プロダクトデザイナー",
    "persona2Pain": "デザイン原則、システムトークン、コンポーネントの根拠が 3 つの Figma、2 つの Notion、47 個の Loom スレッドに散在。AI デザイン対話は次のスプリントで sentence case vs title case を選んだ理由を忘れる。",
    "persona2Role": "Diego — fintech のスタッフプロダクトデザイナー、デザインシステム + 4 つの製品面を担当",
    "persona2Snippet": "\"3 面にまたがる sentence case 違反を 5 秒で検出。以前はデザインレビュー前に毎回 30 分の監査が必要だった。\"",
    "persona2SnippetLabel": "DOGFOOD より · 第 6 週",
    "persona2Tag": "№ 02 · プロダクトデザイナー",
    "personasHeadingLine1": "2 つの役割。",
    "personasHeadingLine2Em": "コストになる",
    "personasHeadingLine2Part1": "コンテキスト消失が",
    "personasHeadingLine2Part2": "2 つの瞬間。",
    "personasIntro": "1 つの製品変更が依存するすべての決定の書き直しに連鎖する場面で、Draftlize の真価が出ます。PM とプロダクトデザイナーがこれを最も強く感じるのは、彼らの思考そのものが成果物だからです。",
    "personasLabel": "図 2 · Draftlize を必要とする人",
    "pricingTrust1": "登録で $5 進呈",
    "pricingTrust2": "いつでもデータエクスポート",
    "pricingTrust3": "ロックインなし · いつでもエクスポート",
    "problem1Body": "第 3 週に価格を決めました。第 7 週、新しいチャットで、あなたとエージェントは同じトレードオフをゼロから議論し直します — チャットログに参照可能なものが何もないからです。",
    "problem1Num": "I",
    "problem1Title": "決定がスプリントごとに蒸し返される",
    "problem2Body": "前提を 1 つ変更すると — オンボーディングフロー、ターゲット層、価格帯 — それに依存するすべてのドキュメントが静かに腐っていきます。デモ当日にどれが該当するか分かります。",
    "problem2Num": "II",
    "problem2Title": "仕様が誰にも気付かれずに drift する",
    "problem3Body": "新しいチャット、新しい健忘症。「なぜ freemium モデルを却下したか」を 5 回目の説明。複利で積み上がるべき context が、積み上がりません。",
    "problem3Num": "III",
    "problem3Title": "エージェントは会話のたびにあなたを忘れる",
    "problemHeading": "AI 支援プロダクト作業で静かに起きる",
    "problemHeadingEm": "3 つの痛み。",
    "pullQuote": "agent と 1 時間思考しても、何も残らないことがある — 成果物が記憶しない限り。",
    "pullQuoteCite": "Draftlize ドッグフードログより · 2026-02",
    "surfaceClaudeCitedBody": "前払いウォレット · 従量課金 · 残高は失効しない",
    "surfaceClaudeReplyPrefix": "出典:",
    "surfaceClaudeTitle": "C · CLAUDE CODE",
    "surfaceClaudeUserMsg": "価格カードには実際に何と書いてある?",
    "surfaceClaudeWhoYou": "YOU",
    "surfaceWebCaption": "→ kind グリフ付きでレンダリング、ホバーで STALE グラフのプレビュー、ドラッグで並べ替え、クリックで完全な履歴ドロワー",
    "surfaceWebCardBody": "前払いウォレット · 従量課金 · 残高は失効しない",
    "surfaceWebCardMeta": "3 DEPENDENTS · LAST EDITED 14m AGO · BY YOU",
    "surfaceWebTitle": "A · WEB UI · CardPeek",
    "surfacesHeadingEm": "ファーストクラス context にする 2 つの面。",
    "surfacesHeadingPart1": "カードを",
    "surfacesIntroPart1": "Draftlize web アプリ + Claude Code 統合。同じカード、",
    "surfacesIntroPart2": "どちらからもアドレス可能。開発者向けの完全な面集（CLI、MCP、生 markdown）は下記の開発者ページに。",
    "surfacesLabel": "図 3 · カードの居場所",
    "testimonial1Quote": "火曜に魔法システムを変えた。水曜には 20 枚の依存カードを片付けていた。STALE 伝播がなかったら、1 ヶ月分のバグ報告になっていたはず。",
    "testimonial1Role": "ソロ開発者 · roguelike",
    "testimonial2Quote": "スレッド間のコンフリクトが、メモを送る前に 2 つのバイオテック報告の間のガイダンス不一致を捕まえてくれた。一度評判を救われるまで気づかない種類のキャッチ。",
    "testimonial2Role": "調査ジャーナリスト",
    "testimonial3Quote": "Claude Code の環境コンテキストとしてのカードが、キラームーブ。「先週何を決めたか」と agent が訊かなくなる — 先週はリポジトリにそのままあるから。",
    "testimonial3Role": "インディーハッカー · B2B ツール",
    "voicesHeadingEm": "そして寄せられる質問。",
    "voicesHeadingPart1": "ドッグフードユーザーの声。"
  },
  "import": {
    "changeFile": "クリックまたは別ファイルをドロップで変更",
    "dropZone": "draftlize エクスポートの .zip をここにドロップ",
    "dropZoneHint": "またはクリックしてファイルを選択",
    "errNotZip": ".zip ファイルが必要です。受信したのは {{name}}",
    "heading": "プロジェクトをインポート",
    "importButton": "インポート →",
    "importing": "インポート中…",
    "projectNameLabel": "プロジェクト名(任意)",
    "projectNamePlaceholder": "空欄の場合は「<元の名前> (imported)」を使用"
  },
  "login": {
    "codeHint": "Or type the 6-digit code from the email:",
    "codeInvalid": "Invalid or expired code — check the email or request a new one.",
    "codeSubmit": "Sign in",
    "emailPlaceholder": "you@example.com",
    "errorSendFailed": "送信できませんでした。再試行するか、GitHub / Google をお使いください。",
    "inviteInvalid": "This invite code is invalid or already used",
    "invitePlaceholder": "Invite code",
    "inviteRequired": "An invite code is required to sign up",
    "noInviteWaitlist": "No invite code? Join the waitlist",
    "sendMagicLink": "マジックリンクを送信",
    "sending": "送信中…",
    "sentBodyPrefix": "サインインリンクをお送りしました: ",
    "sentBodySuffix": "。リンクは 15 分で期限切れとなり、1 回のみ使用できます。",
    "sentTitle": "メールをご確認ください",
    "separatorOr": "または",
    "signInWithGitHub": "GitHub でサインイン",
    "signInWithGoogle": "Google でサインイン",
    "tagline": "思考のための agent",
    "useDifferentEmail": "別のメールを使用",
    "waitlistBack": "Back to sign in",
    "waitlistIntro": "Draftlize is in limited beta. Leave your email and we’ll send you an invite as we open up.",
    "waitlistJoin": "Join waitlist",
    "waitlistJoinedBody": "We’ll email you an invite code as spots open up.",
    "waitlistJoinedTitle": "You’re on the list",
    "wechatHint": "Sign in with your email — we’ll send you a login link."
  },
  "refs": {
    "attach": "添付",
    "attachTitle": "現在のメッセージに添付",
    "confirmDelete": "ref「{{name}}」を削除しますか?",
    "dismissError": "クリックで閉じる",
    "emptyState": "refs はまだありません — ファイルをドロップするか下のアップロードを使用",
    "errDelete": "削除: {{message}}",
    "errLoad": "refs の読み込み: {{message}}",
    "errRead": "読み取り: {{message}}",
    "heading": "PROJECT REFS",
    "peekTitle": "内容をプレビュー",
    "sharedAcrossThreads": "スレッド間で共有",
    "uploadNew": "+ 新規アップロード",
    "uploading": "{{count}} 件をアップロード中…"
  },
  "settings": {
    "adminBadge": "admin",
    "adminTools": "ADMIN TOOLS",
    "adminToolsHint": "概要、LLM 使用量、エラートリアージ、ユーザー。",
    "buildBinaryHint": "まずバイナリをビルド: <code>cargo build --release -p draftlize-mcp</code>",
    "copied": "✓ コピー済み",
    "copy": "コピー",
    "copyCommand": "コマンドをコピー",
    "copyToken": "トークンをコピー",
    "createToken": "トークンを作成",
    "creating": "作成中…",
    "deleteConfirm": "「{{name}}」を完全に削除しますか? カード、スレッド、履歴がすべて失われます。この操作は元に戻せません。",
    "deleteProject": "プロジェクトを削除…",
    "deleting": "削除中…",
    "errClipboard": "クリップボードへの書き込みに失敗 — テキストを選択して手動でコピーしてください",
    "errCreateToken": "トークンの作成: {{error}}",
    "errDelete": "削除: {{error}}",
    "errMcpToggle": "MCP の切替: {{error}}",
    "errRevokeToken": "トークンの取り消し: {{error}}",
    "errUpdatePack": "pack の更新: {{error}}",
    "heading": "設定",
    "integrationsBlurb": "外部 AI ツール(Claude Code、Cursor、Claude Desktop)が <mcp>MCP</mcp> 経由でこのプロジェクトのカードを読み取れるようにします。読み取り専用 — このチャネルからカードを編集することはできません。",
    "wizardTitle": "Claude Code を接続",
    "wizardBlurb": "このプロジェクトのカードをリポジトリに同期し、Claude Code（や他のコーディングエージェント）と同じ意思決定メモリを共有——ビルド中の発見も書き戻されます。",
    "wizardStep1": "API トークンを生成",
    "wizardGenerate": "トークンを生成",
    "wizardHaveTokens_one": "有効なトークンが {{count}} 件あります——シークレットを保存済みなら再利用、またはこのマシン用に新規作成。",
    "wizardHaveTokens_other": "有効なトークンが {{count}} 件あります——シークレットを保存済みなら再利用、またはこのマシン用に新規作成。",
    "wizardStep2": "CLI をインストールしてこのプロジェクトをリンク",
    "wizardTokenPlaceholder": "<あなたの dft_… トークン>",
    "wizardCopyAll": "4 つのコマンドをすべてコピー",
    "wizardStep2Hint": "ローカル dev サーバーに接続する場合は先に DRAFTLIZE_API_URL を export してください。",
    "wizardStep3": "接続ステータス",
    "wizardNoToken": "トークン待ち——まずステップ 1 を完了してください。",
    "wizardWaiting": "最初の CLI 呼び出しを待っています……10 秒ごとに自動チェック。",
    "wizardConnected": "接続済み——トークン「{{name}}」が{{time}}にアクティブ。",
    "wizardIdle": "最後の CLI アクティビティは {{time}}——draftlize pull を実行すると再接続します。",
    "wizardTryNext": "接続完了！次は Claude Code 内で <code>/draftlize:status</code> を試してください。",
    "wizardDevMcp": "ローカル DEV · MCP サーバー（POSTGRES 直結）",
    "wizardDevMcpBlurb": "MCP stdio サーバーは Postgres に直接接続します——データベースに到達できる環境（ローカル dev）専用。それ以外のマシンでは上の CLI パスを使ってください。",
    "inviteCopied": "Copied",
    "inviteCopy": "Copy",
    "inviteRevoked": "Revoked",
    "inviteUsed": "Used",
    "invitesEmpty": "No codes yet. Use Draftlize for a week and grow your project past 20 cards, and 3 invite codes will appear here.",
    "invitesGrantedNow": "You just earned 3 invite codes — thanks for building with us. Share them with people who think out loud.",
    "invitesIntro": "Draftlize is in limited beta — invites let friends skip the waitlist. You earn 3 codes after a week of use and 20 cards.",
    "invitesLoadFailed": "Could not load invites — try again later.",
    "languageHint": "UI と agent の応答言語を設定します。カード内容は翻訳されません。",
    "languageLabel": "言語",
    "loading": "Loading…",
    "localeAuto": "自動(ブラウザに従う)",
    "navAccount": "アカウント",
    "navBilling": "請求",
    "navGeneral": "一般",
    "navIntegrations": "連携",
    "navInvites": "Invites",
    "navTokens": "API トークン",
    "noExternalReads": "外部からの読み取りはまだありません",
    "noProjectGeneral": "一般設定にアクセスするにはプロジェクトを開いてください。",
    "noProjectIntegrations": "MCP 連携を管理するにはプロジェクトを開いてください。",
    "noTokens": "トークンはまだありません",
    "oneTimeInstall": "ONE-TIME INSTALL(ターミナルで)",
    "openAdminPanel": "管理パネルを開く",
    "packBlank": "空白",
    "pasteIntoShell": "シェルに貼り付けてください:",
    "reallyDelete": "本当に削除",
    "reallyRevoke": "本当に取り消す",
    "recentAccess": "RECENT ACCESS",
    "relDays_one": "{{count}}日前",
    "relDays_other": "{{count}}日前",
    "relHours_one": "{{count}}時間前",
    "relHours_other": "{{count}}時間前",
    "relMinutes_one": "{{count}}分前",
    "relMinutes_other": "{{count}}分前",
    "relSeconds_one": "{{count}}秒前",
    "relSeconds_other": "{{count}}秒前",
    "relYesterday": "昨日",
    "renameHint": "サイドバーで名前変更(ダブルクリック)",
    "revoke": "取り消す",
    "revoking": "取り消し中…",
    "rowEmail": "メール",
    "rowGithub": "GitHub",
    "rowName": "名前",
    "rowPack": "Pack",
    "rowProjectId": "プロジェクト ID",
    "rowStatus": "ステータス",
    "rowTenant": "テナント",
    "savedDismiss": "保存しました — 閉じる",
    "saving": "保存中…",
    "sectionIntegrations": "INTEGRATIONS",
    "sectionProject": "PROJECT",
    "sectionTokens": "API TOKENS",
    "session": "SESSION",
    "signOut": "サインアウト",
    "signedInAs": "SIGNED IN AS",
    "signingOut": "サインアウト中…",
    "statusConnected_one": "接続済み · 24h で {{count}} 回読み取り",
    "statusConnected_other": "接続済み · 24h で {{count}} 回読み取り",
    "statusDisabled": "このプロジェクトでは無効",
    "statusSetUp": "セットアップ済み · 読み取りはまだなし",
    "statusUnavailable": "利用不可",
    "toggleDisable": "このプロジェクトの MCP を無効化",
    "toggleDisableTitle": "このプロジェクトを MCP クライアントから非表示(既存の読み取りは記録され続けますが、新規読み取りは拒否されます)",
    "toggleEnable": "このプロジェクトの MCP を有効化",
    "toggleEnableTitle": "このプロジェクトを MCP クライアントに再公開",
    "tokenCreated": "作成日",
    "tokenCreatedNotice": "<name>{{name}}</name> — 今すぐコピーしてください。完全なトークンは一度だけ表示され、後から取得できません。",
    "tokenLastUsed": "最終使用 {{time}}",
    "tokenNamePlaceholder": "トークン名(例: laptop、ci-bot)",
    "tokenNeverUsed": "未使用",
    "tokensBlurb": "<code>draftlize</code> CLI と外部 MCP クライアント向けの長期 bearer トークン。各トークンはあなたのユーザーとして認証されます — パスワードと同じように扱ってください。",
    "unknownClient": "unknown",
    "unverified": "未認証"
  },
  "sidebar": {
    "admin": "ADMIN",
    "adminTitle": "Admin · 概要 / 使用量 / エラー / ユーザー",
    "archiveThread": "スレッドをアーカイブ",
    "collapse": "サイドバーを折りたたむ",
    "create": "CREATE",
    "doubleClickRename": "ダブルクリックで名前変更",
    "expand": "サイドバーを展開",
    "importFromZip": ".zip からインポート",
    "mcpChipTitle": "MCP 連携 · 設定 → 連携を開く",
    "mcpChip_one": "⚡ MCP · {{count}} 回読み取り",
    "mcpChip_other": "⚡ MCP · {{count}} 回読み取り",
    "newEmptyProject": "+ 新規の空プロジェクト",
    "newMenu": "+ NEW",
    "newThread": "+ NEW",
    "noThreads": "スレッドはまだありません — 始めましょう",
    "openAccount": "アカウントを開く",
    "openAccountAria": "アカウント設定を開く",
    "openAccountTitle": "{{identity}} — アカウントを開く",
    "projectNamePlaceholder": "プロジェクト名…",
    "projects": "PROJECTS",
    "settings": "SETTINGS",
    "tagline": "思考のための agent",
    "threads": "THREADS",
    "untitled": "無題"
  },
  "tips": {
    "cardShortcuts": "カードを開いてから、n で新規 · e で編集 · esc で閉じる",
    "dragFile": "ファイルをコンポーザーにドラッグすると、プロジェクト ref として添付できます",
    "editHistory": "カードは完全な編集履歴を保持 — カードを開いて履歴ドロワーをタップ",
    "exportProject": "カードパネルのフッターにある「N cards」をクリックすると、プロジェクト全体をダウンロードできます",
    "hideTips": "ヒントを非表示",
    "importZip": "サイドバーの + NEW ▾ から draftlize の .zip エクスポートをインポートすることもできます",
    "newline": "⇧↵ で改行 · ↵ で送信",
    "nextTip": "次のヒント",
    "projectRefs": "📎 はプロジェクト refs を一覧 — 添付、プレビュー、アップロード、削除が可能",
    "renameDoubleClick": "プロジェクトやスレッドの名前をダブルクリックすると変更できます",
    "settings": "⚙ 設定(サイドバー下部)で pack の切替やプロジェクトの削除が可能"
  },
  "usage": {
    "autoCompactionAt": "{{tokens}}({{pct}}%)で自動コンパクション",
    "breakdownNextTurn": "BREAKDOWN (NEXT TURN)",
    "cacheRead": "キャッシュ読み取り",
    "cacheWrite": "キャッシュ書き込み",
    "chipTitle": "コンテキスト: {{input}} / {{window}}({{pct}}%) — クリックで詳細",
    "compactedThisTurn_one": "📦 このターンで {{count}} 件のメッセージをコンパクション",
    "compactedThisTurn_other": "📦 このターンで {{count}} 件のメッセージをコンパクション",
    "compactionActive": "自動コンパクションが有効",
    "compactionActiveBody_one": "{{count}} 件の古いメッセージが構造化サマリーに置き換えられ、LLM が入力予算内に収まるようにします。完全な履歴はスレッドに残ります — LLM のビューだけが切り詰められます。",
    "compactionActiveBody_other": "{{count}} 件の古いメッセージが構造化サマリーに置き換えられ、LLM が入力予算内に収まるようにします。完全な履歴はスレッドに残ります — LLM のビューだけが切り詰められます。",
    "compactionActiveLabel": "📦 コンパクション有効:",
    "compactionHint": "自動コンパクションはオレンジの線({{tokens}})で発火します。古いメッセージは構造化サマリーに置き換えられます。完全な履歴はスレッドに残ります。",
    "contextWindow": "CONTEXT WINDOW",
    "freeSpace": "空き容量",
    "input": "入力",
    "messages": "メッセージ",
    "messagesCompacted_one": "メッセージ({{count}} 件コンパクション済み)",
    "messagesCompacted_other": "メッセージ({{count}} 件コンパクション済み)",
    "mobileChipAria": "コンテキストウィンドウ {{pct}}% — タップで詳細",
    "mobileSheetAria": "コンテキストウィンドウの詳細",
    "mobileSheetTitle": "コンテキスト · {{input}} / {{window}}({{pct}}%)",
    "output": "出力",
    "sessionTotals": "SESSION TOTALS (PROVIDER)",
    "systemPrompt": "システムプロンプト",
    "toolsSchema": "ツールスキーマ",
    "withoutCompaction": "コンパクションなし"
  },
  "marketing": {
    "footerProduct": "製品",
    "navForDevelopers": "開発者向け",
    "navForPm": "PM 向け",
    "navHome": "ホーム",
    "navOpenApp": "アプリを開く →",
    "navStart": "無料で始める →",
    "navPricing": "価格"
  },
  "pricing": {
    "heroLabel": "価格",
    "prepaidHeroTitle": "プリペイド式。お支払いは",
    "prepaidHeroTitleEm": "使った分だけ — それ以外は一切なし。",
    "prepaidLede": "サブスクなし、階層なし、月額請求なし。登録すると $5 のクレジットが進呈され、あとは実際に使った AI 利用分だけをお支払いいただきます。チャージは $5 からいつでも可能。使い切らなかった残高はウォレットにそのまま残り、失効することはありません。",
    "prepaidHeroCta": "$5 無料で始める",
    "pointsHeadingPart1": "ごまかさない仕組みを支える",
    "pointsHeadingEm": "3 つのこと。",
    "pointsSubhead": "公開された一律レートでトークン単位の従量課金。席数も階層も、想定外の請求書もありません。",
    "point1Title": "無料で始められる",
    "point1Tag": "登録時にクレジット進呈",
    "point1Body": "新規アカウントにはどなたにも $5 を進呈。最初はカード登録も不要です。1 円も払う前に、実際のプロジェクトを立ち上げて使い心地を確かめるのに十分な額です。",
    "point2Title": "従量課金",
    "point2Tag": "トークン単位で課金",
    "point2Body": "無料クレジットを使い切ったら、$5 からチャージしてそのまま続行。実際に使ったトークン分だけを一律レートでお支払いいただきます。席数や、いずれ手狭になるプランへの課金は一切ありません。",
    "point3Title": "失効しない",
    "point3Tag": "残高はあなたのもの",
    "point3Body": "購入したクレジットが月末に消えることはありません。1 四半期離れていても、戻ってくれば残高は離れたときのまま。更新も解約も不要です。",
    "qaPrepaid1Q": "課金は実際どう動くのですか?",
    "qaPrepaid1A": "AI リクエストごとにセント単位のトークン費用が設定されており、作業に応じてウォレットから差し引かれます。最初は $5 が無料で、残高が少なくなったら $5 からチャージ。サブスクも月額料金もなく、お支払いは利用分だけです。",
    "qaPrepaid2Q": "始めるのにクレジットカードは必要ですか?",
    "qaPrepaid2A": "いいえ。登録した瞬間に $5 のスタータークレジットが入っています。それを超えてチャージするときだけカードを追加します。しかもそれは 1 回限りの課金で、継続的なサブスクではありません。",
    "qaPrepaid3Q": "残高がなくなったらどうなりますか?",
    "qaPrepaid3A": "リクエストはエラーになるのではなく一時停止するので、知らないうちに課金されることはありません。設定 → 請求から $5 からチャージすればクレジットは即座に反映され、中断したところからそのまま再開できます。",
    "qaPrepaid4Q": "クレジットは失効しますか?",
    "qaPrepaid4A": "失効しません。チャージした分はウォレットに無期限で残ります。忙しい月も静かな月も、残高は繰り越され、更新も解約も不要です。",
    "qaPrepaid5Q": "月額プランや階層はまだありますか?",
    "qaPrepaid5A": "いいえ — 従来の Pro / Power / Max の階層は廃止しました。どなたも Draftlize の全機能を使え、同じトークン単価をお支払いいただきます。違うのは使う量だけです。",
    "prepaidFinalBody": "$5 無料で始めて、使った分だけ払い、使わなかった分は 1 円残らずあなたのもの。それがこの仕組みのすべてです。",
    "pageDescription": "従量課金（pay-as-you-go）。登録で $5 クレジット進呈、すぐに完全な Draftlize：カードグラフ、stale 伝播、スレッド間競合検出、Claude Code + MCP 統合。使った分だけ残高から差し引き、残高は失効しません。$5 からチャージ、サブスクなし・解約不要。",
    "pageTitle": "価格 · Draftlize — 従量課金、登録で $5 進呈",
    "qaHeading": "価格に関する質問"
  },
  "forPm": {
    "ctaBody": "登録で $5 クレジット進呈、あとは従量課金で全機能。残高は失効せず、サブスクも解約も不要。多くの PM が最初の週で再説明時間を 50% 削減できたと報告。",
    "ctaButton": "無料で始める",
    "ctaTitle": "Draftlize の全機能。",
    "ctaTitleEm": "従量課金。",
    "heroLabel": "プロダクトマネージャー向け",
    "heroLede": "あなたはすでにプロダクト思考を AI チャットに移しました。それを失うのを止めましょう。Draftlize はすべての決定、依存、根拠を、エージェントが読み書きできるアドレス可能なカードとして保持——context はスプリント間で複利化し、蒸発しません。",
    "heroTitle": "AI 思考パートナーとロードマップを",
    "heroTitleEm": "進める PM のために。",
    "pageDescription": "AI エージェントとロードマップを進める PM 向けのワークベンチ。すべての spec、決定、根拠がアドレス可能なカードに。spec を 1 つ変更すると、依存スレッドが自動 stale 表示。AI 支援 PM 時間を ~50% 削減。",
    "pageTitle": "プロダクトマネージャー向け · Draftlize — AI への context 再説明を止める",
    "scenario1Body": "第 3 週に料金モデルを決定。第 7 週、新しいチャットで、エージェントが c-04（価格決定）を ambient context として読み込み——そこから開始。すでに行った分析の再説明は不要。",
    "scenario1Title": "価格決定が蒸し返されない",
    "scenario2Body": "オンボーディングフロー（c-12）を変更。c-12 に依存するすべての PRD セクション、デザイン doc、Claude 会話が自動 stale 表示。デモ当日までに drift を一掃済み。",
    "scenario2Title": "仕様が静かに drift しない",
    "scenario3Body": "スレッド A で「ターゲット SMB」と言い、スレッド B（1 週間後）で「ターゲットミッドマーケット」と言う。Draftlize の競合検出器は gap_kind=conflict カードとして提出。出荷前に両方を同時に確認できます。",
    "scenario3Title": "スレッド間の競合が gap として表面化"
  },
  "forDevelopers": {
    "ctaBody": "登録で $5 クレジット進呈、あとは従量課金で全機能。残高は失効せず、サブスクも解約も不要。CLI + MCP + スラッシュコマンドはすべて含まれます。",
    "ctaButton": "無料で始める",
    "ctaTitle": "コード context としてのカード。",
    "ctaTitleEm": "drift しない spec。",
    "heroLabel": "開発者向け",
    "heroLede": "Draftlize カードが substrate。CLI はリポジトリに markdown としてミラー。MCP server は Claude Code / Cursor / Claude Desktop にファーストクラス context として公開。c-12 を実装したら built マーク——spec が動くとステータスが drift_detected に自動切替、何を再訪すべきか分かります。",
    "heroTitle": "あなたの決定を、",
    "heroTitleEm": "使うすべての AI ツールでアドレス可能に。",
    "pageDescription": "AI エージェントによる spec 駆動開発のための Draftlize。CLI がカードをリポジトリにミラー。MCP server がカードを Claude Code / Cursor / Claude Desktop のファーストクラスリソースに。spec が動くと実装ステータスは drift_detected に自動切替。",
    "pageTitle": "開発者向け · Draftlize — Claude Code / Cursor / MCP のファーストクラス context",
    "surface1Body": "カードは `.draftlize/cards/<id>.md` に YAML frontmatter 付きのプレーン markdown として配置。Claude Code が ambient context として読む。`draftlize flag c-7 \"...\"` で gap カードを GapLedger に書き戻し。",
    "surface1Title": "CLI —— `draftlize pull` でリポジトリへ",
    "surface2Body": "独立した `draftlize-mcp` バイナリが stdio で JSON-RPC を話す。ツール：`read_card` / `list_cards` / `search_cards` / `propose_card`（fact/statement/question にロック）。URI：`draftlize://<slug>/<cid>` は `/api/resolve` で解決。",
    "surface2Title": "MCP server —— stdio JSON-RPC",
    "surface3Body": "`draftlize link <project>` の後、4 つのスラッシュコマンドが `.claude/skills/draftlize/` に配置：`/draftlize:cite` / `/draftlize:flag` / `/draftlize:fact` / `/draftlize:status`。Claude Code がインラインで解決。",
    "surface3Title": "スラッシュコマンド —— `/draftlize:cite c-7`",
    "surface4Body": "`draftlize mark-built c-12` でカードのステータスが `built` に切替。後でカードを編集するとステータスは `drift_detected` に自動切替——agent はどのスナップショットから実装され、それ以来何が動いたかを把握。",
    "surface4Title": "implementation_status —— spec drift 追跡"
  },
  "share": {
    "footerCta": "Try Draftlize",
    "footerTagline": "Incubate your ideas with an agent",
    "goneBody": "The share may have been revoked by its owner.",
    "goneTitle": "This link is no longer available",
    "graphStats": "{{cards}} cards · {{edges}} connections"
  },
  "feedback": {
    "body": "Scan to join the WeChat group — direct line to the builder, ship notes, and invite codes.",
    "fab": "Early users",
    "qrAlt": "WeChat group QR code",
    "qrFallback": "Group QR coming soon — ping the friend who invited you.",
    "title": "Join the early-user group"
  },
  "onboarding": {
    "beat1Body": "No commands, no syntax. Just describe what you're working on.",
    "beat1Title": "Talk like you would to a sharp colleague.",
    "beat2Body": "When a decision, fact, or question lands, the agent writes it to the cards panel on the right — yours to edit, link, and keep.",
    "beat2Title": "Key thoughts become addressable cards.",
    "beat3Body": "Edit a card others depend on and Draftlize marks everything downstream — so your thinking stays consistent across weeks.",
    "beat3Title": "Change a decision, dependents flag stale.",
    "kicker": "WELCOME TO DRAFTLIZE",
    "skip": "I'll start on my own",
    "starter1Label": "Incubate a product idea",
    "starter1Prompt": "I'm thinking about building a product. Help me think through the core idea, who it's for, and what the riskiest assumption is.",
    "starter2Label": "Plan a feature",
    "starter2Prompt": "Help me spec a new feature. Ask me clarifying questions first, then we can capture the key decisions as we go.",
    "starter3Label": "Think through a decision",
    "starter3Prompt": "I have a decision to make and I want to reason it out loud with you. Let's lay out the options and the trade-offs.",
    "titleLine1": "Think with an agent.",
    "titleLine2": "Keep the artifact.",
    "tryOne": "TRY ONE TO START"
  }
}
